import { defineComponent as _defineComponent } from 'vue'
import { mdiClose } from '@mdi/js'
import { computed, onMounted, onUpdated, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { OnboardingForm } from '@/widgets/Onboarding'
import StartFormSignup from './StartFormSignup.vue'

type AuthForm = typeof StartFormSignup | typeof OnboardingForm

export default /*#__PURE__*/_defineComponent({
  __name: 'SignupPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const isIncomplete = ref(!!route.query.incomplete)
const getUserDB = computed(() => store.getters.getUserDB)
const currentForm = ref<AuthForm>(StartFormSignup)
watch(
  () => getUserDB,
  () => {
    if (getUserDB.value.uid) {
      currentForm.value = OnboardingForm
    }
  }
)

onMounted(() => {
  if (!getUserDB.value) return
  currentForm.value = OnboardingForm

  if (getUserDB.value.dancerName) {
    router.push({ name: 'Home' })
  }
})

onUpdated(() => {
  document.body.scrollIntoView()
})

return { __sfc: true,route, router, isIncomplete, getUserDB, currentForm, mdiClose, OnboardingForm }
}

})